import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import {
	TGetPrpPostalOperatorSettingsRequest,
	TPrpPostalOperatorSettingsListResponse,
	TPrpSettings,
	TPrpStore,
} from './types';

export const getPrpState = (state: TStoreState): TPrpStore => state.prp;

// ========================================== Settings

export const getPrpSettings = createSelector(
	[getPrpState],
	(prp: TPrpStore): TPrpSettings | null => prp.settings,
);

export const getPrpSettingsLoading = createSelector(
	[getPrpState],
	(prp: TPrpStore): boolean => prp.settingsLoading,
);

export const getPrpSettingsSaveLoading = createSelector(
	[getPrpState],
	(prp: TPrpStore): boolean => prp.settingsSaveLoading,
);

export const getPrpSettingsSaveSuccess = createSelector(
	[getPrpState],
	(prp: TPrpStore): boolean => prp.settingsSaveSuccess,
);

// ========================================== Postal operator settings

export const getPrpPostalOperatorSettingsList = createSelector(
	[getPrpState],
	(prp: TPrpStore): TPrpPostalOperatorSettingsListResponse | null => prp.postalOperatorSettingsList,
);

export const getPrpPostalOperatorSettingsListLoading = createSelector(
	[getPrpState],
	(prp: TPrpStore): boolean => prp.postalOperatorSettingsListLoading,
);

export const getPrpPostalOperatorSettingsLastListParams = createSelector(
	[getPrpState],
	(prp: TPrpStore): TGetPrpPostalOperatorSettingsRequest | null =>
		prp.postalOperatorSettingsLastListParams,
);

export const getPrpPostalOperatorSettingsSaveLoading = createSelector(
	[getPrpState],
	(prp: TPrpStore): boolean => prp.postalOperatorSettingsSaveLoading,
);

export const getPrpPostalOperatorSettingsSaveSuccess = createSelector(
	[getPrpState],
	(prp: TPrpStore): boolean => prp.postalOperatorSettingsSaveSuccess,
);
